import { laceDrawer } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/lace'
import { laceOfBackOfArroundWebDrawer } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/lace/arroundWeb'
import { laceOfKnots } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/lace/knots'
import { littleMachi } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/littleMachi'
import { stitch } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/stitch'
import { thumbMachi } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/thumbMachi'
import { State } from 'src/types'
import { catchFaceDrawer } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/catchFace'
import { canvasResetter } from 'src/features/brands/gorilla/canvas/common/canvasResetter'
import { webDrawer } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/web'
import { edgeDrawer } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/edge'
import { gorillaEngravedOfCatchFace } from 'src/features/brands/gorilla/canvas/labels/gorilla'

export const gorillaCanvasCatcherMittFront = (ctx: CanvasRenderingContext2D, state: State): void => {
  // リセット
  canvasResetter(ctx)
  laceOfKnots(ctx, state.lace.color)
  laceOfBackOfArroundWebDrawer(ctx, state)
  webDrawer(ctx, state)
  catchFaceDrawer(ctx, state)

  thumbMachi(ctx, state.thumbMachi?.color)
  littleMachi(ctx, state.littleMachi?.color)

  // edge(ctx, state.edge.color)
  edgeDrawer(ctx, state)

  stitch(ctx, state.stitch.color)
  laceDrawer(ctx, state)
  // メーカーの刻印
  gorillaEngravedOfCatchFace(ctx, state.catchFace.color, -20, -30)
}
